<template>
    <div v-if="profile" class="row justify-content-center">
        <div class="form-container d-flex flex-column align-items-center">
            <h2 class="title-text mx-auto">
                {{ title }}
            </h2>

            <div class="row mx-0">
                <div class="col px-4">
                    <ValidationObserver ref="passwordObserver">
                        <form id="changePassword">
                            <v-input class="d-none" type="text" autocomplete="username" :value="profile.mail" />

                            <v-input
                                v-if="profile.passwordExists"
                                v-model="currentPassword"
                                class="input-w-default mb-0 mt-2"
                                ind="6"
                                :type="openCurrentPassword ? 'text' : 'password'"
                                name="currentPassword"
                                :placeholder="$t('placeholder.oldPassword')"
                                :icon="$getInputIcon(currentPassword, 'password')"
                                rules="required|validPassword"
                                autocomplete="current-password"
                            >
                                <template #password>
                                    <password-eye v-model="openCurrentPassword" />
                                </template>
                            </v-input>

                            <v-input
                                v-model="password"
                                class="input-w-default mb-0 mt-2"
                                ind="7"
                                type="password"
                                name="password"
                                :placeholder="$t('placeholder.newPassword')"
                                :icon="$getInputIcon(password, 'password')"
                                :rules="{required: true, min: 6, newPassword: currentPassword}"
                                autocomplete="new-password"
                            />

                            <v-input
                                v-model="passwordConfirm"
                                class="input-w-default input-w-default mb-0 mt-2"
                                ind="8"
                                type="password"
                                name="passwordConfirm"
                                :placeholder="$t('placeholder.repeatPassword')"
                                :icon="$getInputIcon(passwordConfirm, 'password')"
                                rules="required|confirmed:password"
                                autocomplete="new-password"
                            />
                        </form>

                        <b-button class="center-element change-button" @click="changePassword">
                            {{ $t('button.save') }}
                        </b-button>

                        <router-link v-if="profile.passwordExists" class="center-element small text-link mb-2" to="/restore/request">
                            {{ $t('message.forgotPassword') }}
                        </router-link>
                    </ValidationObserver>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VInput from './VInput';
    import PasswordEye from './PasswordEye.vue';
    import api from '@/api';
    import { USER_UPDATE } from 'mutations/user';
    import { mapGetters } from 'vuex';

    export default {
        name: 'ChangePassword',

        components: {
            VInput,
            PasswordEye
        },

        computed: {
            ...mapGetters('user', [ 'profile' ]),

            title() {
                return this.profile.passwordExists ? this.$t('title.editPassword') : this.$t('title.creatingPassword');
            }
        },

        data() {
            return {
                currentPassword: '',
                password: '',
                passwordConfirm: '',
                openCurrentPassword: false
            };
        },

        methods: {
            async changePassword() {
                this.openCurrentPassword = false;

                let isValid = await this.$refs.passwordObserver.validate();

                if (!isValid)
                    return;

                try {
                    let body = {
                        password: this.password,
                        passwordConfirm: this.passwordConfirm
                    };

                    if (this.profile.passwordExists)
                        body.currentPassword = this.currentPassword;

                    let response = await api.post('/app/account/password', body);

                    if (response && response.status === this.$defines.RESPONSE_STATUS.OK) {
                        this.$store.commit(`user/${USER_UPDATE}`, { passwordExists: true });

                        await this.$router.push('/account?passwordChanged=true');
                    }
                }
                catch (error) {
                    if (error.response.status === this.$defines.RESPONSE_STATUS.INCORRECT_DATA)
                        this.$store.commit(`user/${USER_UPDATE}`, { passwordExists: false });
                }
            }
        }
    };
</script>

<style scoped>
    .title-text {
        font-weight: lighter !important;
        font-size: 23px;
        line-height: 27px;
        text-decoration: none !important;
        padding-bottom: 2px;
        border-bottom: 1px solid #FFFFFF;
        color: white;
        text-align: center;
        text-decoration-skip-ink: none;
        width: 50%;
    }

    .center-element {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-left: auto;
        margin-right: auto;
    }

    .password-button,
    .change-button {
        align-items: center;
        display: -ms-flexbox;
        margin-top: 3rem;
    }

    .password-button {
        background-color: #9DE8A9;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        width: 248px;
        height: 40px;
        position: relative;
    }

    .change-button {
        background-color: transparent;
        border: 1px solid #338DC9;
        border-radius: 5px;
        width: 50%;
        margin-bottom: 1rem;
    }

    .change-button:hover {
        background-color: #338DC9 !important;
    }

    .text-link {
        color: #29ABE2 !important;
        width: fit-content;
    }
</style>